export enum ClaraEscalationBranch {
  HUMAN_REQUESTED = 'HUMAN_REQUESTED',
  PLATFORM_ISSUE = 'PLATFORM_ISSUE',
  OUT_OF_SCOPE_OFFTOPIC = 'OUT_OF_SCOPE_OFFTOPIC',
  UPGRADE = 'UPGRADE',
  ANSWER = 'ANSWER',
  KNOWLEDGE_GAP = 'KNOWLEDGE_GAP',
  SYSTEM_ERROR = 'SYSTEM_ERROR'
}
